import { createSlice } from '@reduxjs/toolkit'
import { fetchCrashGameReport, fetchCasinoGameReport, fetchCustomGameReport, fetchSportsBookReport } from 'redux-thunk/thunk/gameReports'

const initialState = {
  crashGameReport: null
}

const gameReportsSlice = createSlice({
  name: 'gameReportsSlice',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCrashGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          crashGameReport: action.payload
        }
      })
      .addCase(fetchCasinoGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          financialReport: action.payload,
          loading: false
        }
      })
      .addCase(fetchCustomGameReport.fulfilled, (state, action) => {
        return {
          ...state,
          financialReport: action.payload,
          loading: false
        }
      })
      .addCase(fetchSportsBookReport.fulfilled, (state, action) => {
        return {
          ...state,
          financialReport: action.payload,
          loading: false
        }
      })
  }
})

export default gameReportsSlice.reducer
